import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../../../../types/navigation';
import { BottomNavBar } from '../../../../components/BottomNavBar';

export const CasketUrnIntroScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();

  const handleCasket = () => {
    navigation.navigate('CasketUrnInputCasket');
  };

  const handleUrn = () => {
    navigation.navigate('CasketUrnInputUrn');
  };

  const handleOther = () => {
    navigation.navigate('CasketUrnInputOther');
  };


  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.mainContent}>
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Image
              source={require('../../../../assets/icons/back.png')}
              style={styles.backIcon}
            />
          </TouchableOpacity>
          <Image
            source={require('../../../../assets/logo.png')}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>

        <ScrollView contentContainerStyle={styles.content}>
          <Text style={styles.title}>Do you know where you would like to be laid to rest after you pass?</Text>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.button, styles.casketButton]}
              onPress={handleCasket}
            >
              <Text style={[styles.buttonText, styles.casketText]}>A Casket</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.button, styles.urnButton]}
              onPress={handleUrn}
            >
              <Text style={[styles.buttonText, styles.urnText]}>A Urn</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.button, styles.otherButton]}
              onPress={handleOther}
            >
              <Text style={[styles.buttonText, styles.otherText]}>Other</Text>
            </TouchableOpacity>
          </View>

          <Text style={styles.description}>
            Deciding where you'd like your remains to be laid to rest—whether in a casket, urn, or another option—provides clear guidance for your loved ones. If you have the chance to make a selection in advance, this too can spare the tough decisions on loved ones and reduce the financial burden on them after you have left.
          </Text>
        </ScrollView>
      </View>
      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  mainContent: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(30),
    position: 'relative',
  },
  backButton: {
    position: 'absolute',
    left: ms(50),
    top: ms(15),
    padding: ms(5),
    zIndex: 1,
  },
  backIcon: {
    width: ms(32, 0.3),
    height: ms(32, 0.3),
    tintColor: '#333',
  },
  logo: {
    width: ms(125, 0.3),
    height: ms(125, 0.3),
  },
  content: {
    flexGrow: 1,
    padding: ms(20),
    alignItems: 'center',
  },
  title: {
    fontSize: ms(28, 0.3),
    fontWeight: '600',
    color: '#2C4364',
    marginTop: ms(-10),
    marginBottom: ms(20),
    textAlign: 'center',
    paddingHorizontal: ms(20),
  },
  description: {
    fontSize: ms(18, 0.3),
    color: '#666666',
    textAlign: 'center',
    marginTop: ms(20),
    paddingHorizontal: ms(30),
    lineHeight: ms(25, 0.3),
  },
  buttonContainer: {
    width: '100%',
    paddingHorizontal: ms(20),
  },
  button: {
    width: '100%',
    borderRadius: ms(30),
    padding: ms(15),
    alignItems: 'center',
    marginBottom: ms(15),
  },
  casketButton: {
    backgroundColor: '#29BFC0',
  },
  urnButton: {
    backgroundColor: '#FF9F64',
  },
  otherButton: {
    backgroundColor: '#29BFC0',
  },
  buttonText: {
    fontSize: ms(16, 0.3),
    fontWeight: '500',
  },
  casketText: {
    color: '#FFFFFF',
  },
  urnText: {
    color: '#FFFFFF',
  },
  otherText: {
    color: '#FFFFFF',
  },
});

export default CasketUrnIntroScreen;
